// src/components/tour_groups_calendar/content/TourGroupDateSectionItem.tsx
import moment from "moment";
import styled from "styled-components";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../App";
import { IconButton, Tooltip } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import TourGroupCardItem from "./TourGroupCardItem";

//------------------------------------------------------------------------

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;

const DateHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(5px);
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 2px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const DateSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const HeaderDateText = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: #333;
`;

const HeaderGroupsText = styled.span`
  font-size: 0.85rem;
  color: #666;
  font-weight: 500;
`;

const DataContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 12px;
  padding: 15px;
  background-color: #f9f9f9;
`;

const EmptyMessage = styled.div`
  grid-column: 1 / -1;
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 0.9rem;
`;

//------------------------------------------------------------------------

interface TourGroupDateSectionItemProps {
  date: string;
  tourGroups: any[];
  refetch: () => void;
  entities: any;
}

const TourGroupDateSectionItem = ({
  date,
  tourGroups,
  refetch,
  entities,
}: TourGroupDateSectionItemProps) => {
  const navigate = useNavigate();
  const { setDayPlannerDate } = useContext(AppContext);

  const handleNavigateToDayPlanner = () => {
    setDayPlannerDate(date);
    navigate("/day_planner");
  };

  return (
    <Container>
      <DateHeaderContainer>
        <DateSection>
          <HeaderDateText>
            {moment(date).format("ddd, DD MMM YYYY")}
          </HeaderDateText>
          <Tooltip title="Open in Day Planner" placement="top" arrow>
            <IconButton
              size="small"
              onClick={handleNavigateToDayPlanner}
              sx={{
                color: "#1976d2",
                padding: "4px",
                "&:hover": {
                  backgroundColor: "rgba(25, 118, 210, 0.08)",
                },
              }}
            >
              <OpenInNewIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </DateSection>
        <HeaderGroupsText>
          {tourGroups.length} {tourGroups.length === 1 ? "Group" : "Groups"}
        </HeaderGroupsText>
      </DateHeaderContainer>
      <DataContainer>
        {tourGroups.length === 0 ? (
          <EmptyMessage>No tour groups for this date.</EmptyMessage>
        ) : (
          tourGroups.map((tourGroup: any) => (
            <TourGroupCardItem
              key={tourGroup._id}
              tourGroup={tourGroup}
              entities={entities}
              refetch={refetch}
            />
          ))
        )}
      </DataContainer>
    </Container>
  );
};

export default TourGroupDateSectionItem;
